import {DataTableCellProps} from "@variocube/app-ui";
import React from "react";
import {Booking} from "../../api";
import {CompartmentLinkIconButton} from "../compartment/CompartmentLinkIconButton";

export function BookingCompartmentCell({row}: DataTableCellProps<Booking>) {
	return <CompartmentLinkIconButton compartment={row.compartment} />;
}
